export enum Choice {
    Yes = 'yes',
    No = 'no'
}